module.exports = __webpack_public_path__ + "img/5.a35b9f97.png";